@if (component.data$ | async; as data) {
  <p [dcpInnerHtml]="data.content | cxSupplementHashAnchors"></p>
}
